import {PAYLOAD_FIELDS_NAMES} from '../utils/guestForm';

const ImagesFields = [
  PAYLOAD_FIELDS_NAMES.document_front_side_scan,
  PAYLOAD_FIELDS_NAMES.document_back_side_scan,
  PAYLOAD_FIELDS_NAMES.signature,
  PAYLOAD_FIELDS_NAMES.biomatch_doc,
  PAYLOAD_FIELDS_NAMES.biomatch_selfie,
];

export {ImagesFields};
